import styled from 'styled-components';

export const ContactsIconContainerStyled = styled.div`
    background-color: #14C6791A;
    border-radius: 4px;
    padding: 8px;
`;